import React from 'react'
import { TimePicker } from 'src/Libs/inputs/react-hook-form'
import { set } from 'date-fns'
import { MinutesStep } from 'src/Libs/dynamic-tariff-settings/constants'
import { Moment } from '@e3dc-react/shell/Libs/moment'
import { ClockPickerView } from '@mui/x-date-pickers'
import { useFormContext, useWatch } from 'react-hook-form'
import { isManualTariffMinuteDisabled } from 'src/Libs/dynamic-tariff-settings/utils/is-manual-tariff-minute-disabled'

type Props = {
  name: string
  disabled?: boolean
  fullWidth?: boolean
  /* allow 23:59 selection value */
  allowEndOfDayMinute?: boolean
}

/**
 * Time Picker for dynamic tariff settings. User can only select hours and minutes.
 */
const DynamicTariffTimerPicker: React.FC<Props> = ({ name, fullWidth, disabled = false, allowEndOfDayMinute = false }) => {
  const { control } = useFormContext()
  const selectedTime: Date | null | undefined = useWatch({ control, name })

  const shouldDisableTime = (value: number, view: ClockPickerView): boolean => {
    if (view !== 'minutes') return false
    return isManualTariffMinuteDisabled(value, selectedTime?.getHours())
  }

  /** year Jan-01-1972. 0 seconds and 0 milliseconds.  */
  const leapYear1972 = {
    year: 1972,
    month: 0,
    date: 1,
    second: 0,
    millisecond: 0,
  }

  const onTransform = (value: Moment | null): Date | null => {
    /** reset values that are not set by user to a default value same as backend. */
    if (!value) return null
    return set(value.toDate(), leapYear1972)
  }
  return (
    <TimePicker
      name={name}
      ampm={false}
      views={['hours', 'minutes']}
      minutesStep={allowEndOfDayMinute ? 1 : MinutesStep}
      shouldDisableTime={allowEndOfDayMinute ? shouldDisableTime : undefined}
      onTransform={onTransform}
      disabled={disabled}
      fullWidth={fullWidth}
    />
  )
}

export default DynamicTariffTimerPicker
